import React from 'react';
import { RefreshCw, Pause } from 'lucide-react';
import { useTimeAgo } from '../hooks/useAutoRefresh';

/**
 * iter83 — Compact "Updated 12s ago [↻]" indicator + manual refresh button.
 * Always visible per user direction.
 */
const RefreshIndicator = ({ refresh, lastUpdated, isFetching, isPaused, testId = 'auto-refresh' }) => {
  const ago = useTimeAgo(lastUpdated);
  return (
    <div data-testid={testId} className="inline-flex items-center gap-2 text-[11px] text-[#A3A3A3]">
      {isPaused ? (
        <span className="inline-flex items-center gap-1 text-[#D4AF37]" title="Auto-refresh paused while you're editing">
          <Pause className="w-3 h-3" /> Paused
        </span>
      ) : (
        <span>Updated {ago}</span>
      )}
      <button
        type="button"
        data-testid={`${testId}-refresh-btn`}
        onClick={() => refresh()}
        disabled={isFetching}
        title="Refresh now"
        className="inline-flex items-center justify-center w-7 h-7 rounded-md border border-[#262626] hover:border-[#D4AF37]/40 hover:text-[#D4AF37] transition-colors"
      >
        <RefreshCw className={`w-3.5 h-3.5 ${isFetching ? 'animate-spin' : ''}`} />
      </button>
    </div>
  );
};

export default RefreshIndicator;
